import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { QUERY_VIEW_PAGES } from 'app/data-studio-redesign/services/data-analysis-helper';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ThemeService } from '@wind-log_library/fe-component-library';
import { UserProfileService } from 'app/shared/user-profile/user-profile.service';

@Component({
    selector: 'app-queries-list',
    templateUrl: './queries-list.component.html',
    styleUrls: ['./queries-list.component.scss'],
    standalone: false
})
export class QueriesListComponent implements OnInit, OnChanges {

  @Input() dataSource;
  @Input() myQueriesView: boolean;
  @Input() title: string;
  @Input() total: number;
  @Output() changePageOptions = new EventEmitter()
  @Output() changeView = new EventEmitter();
  @Output() deleteDataAnalysisQuery = new EventEmitter();
  @Output() createQuery = new EventEmitter();
  @Output() searchForTitle = new EventEmitter();

  @ViewChild('warningDeleteQuery', { static: true })
  private warningDeleteQuery: TemplateRef<any>;

  public queryView = false;
  public displayedColumns = ['id', 'name', 'sites', 'assets', 'queryType', 'period', 'series'];
  public loading: boolean = true;
  public searchQueryTitle: string = '';
  public queryViewPages = QUERY_VIEW_PAGES;
  public modalRef?: BsModalRef;
  public reports: string = '';

  constructor(
    private modalService: BsModalService,
    private userProfileService: UserProfileService,
    private themeService: ThemeService
  ) {}

  public ngOnInit() {
    this.displayedColumns.push('edit');
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.dataSource?.currentValue) {
      this.loading = false;
    }
  }

  public viewDetails({_id: id, queryType}, viewIndex, ) {
    this.changeView.emit({id, viewIndex, myQueriesView: this.myQueriesView, queryView: queryType});
  }

  public action({index}, query) {
    switch (index) {
      case 0:
        this.createQuery.emit({...query, isSharedQuery: false, queryType: query.queryType || 'TIMESERIES'});
        break;
      case 1:
        this.myQueriesView ?
          this.createQuery.emit({...query, isSharedQuery: true, queryType: query.queryType || 'TIMESERIES'}) :
          this.deleteQuery(query._id, query.relatedReports);
        break;
      case 2:
        this.deleteQuery(query._id, query.relatedReports);
        break;
    }
  }

  public addNewQuery({index}) {
    this.changeView.emit({id: null, viewIndex: 0, myQueriesView: false, queryView: this.queryViewPages[index]});
  }

  public setOptions(query) {
    const profile = this.userProfileService.getUserProfile();
    return this.myQueriesView ?
      ['DATA_STUDIO.DATA_ANALYSIS.ALL_QUERIES_VIEW.DUPLICATE', 'DATA_STUDIO.DATA_ANALYSIS.ALL_QUERIES_VIEW.COPY_TO_SHARED', 'BUTTONS.DELETE'] :
      query.createdByUsername === profile?.username ? 
      ['DATA_STUDIO.DATA_ANALYSIS.ALL_QUERIES_VIEW.COPY_TO_MY_QUERIES', 'BUTTONS.DELETE'] :
      ['DATA_STUDIO.DATA_ANALYSIS.ALL_QUERIES_VIEW.COPY_TO_MY_QUERIES'];
  }

  public pageChange(event) {
    this.loading = true;
    this.changePageOptions.emit({pageNumber: event.pageIndex, pageSize: event.pageSize, myQueriesView: this.myQueriesView})
  }

  public searchTitle(value) {
    this.loading = true;
    this.searchForTitle.emit({value, myQueriesView: this.myQueriesView});
  }

  private deleteQuery(queryId: string, relatedReports: {reportName}[] | null): void {
    this.reports = relatedReports?.map(report => report?.reportName).join(', ') || '';
    if (this.reports) {
      this.modalRef = this.modalService.show(
        this.warningDeleteQuery,
        Object.assign({},{
          class: `modal-dialog-data-analysis-delete modal-dialog-centered ${this.themeService.getTheme().value}`,
          close: true,
        }))
    } else {
      this.deleteDataAnalysisQuery.emit(queryId);
    }
  }

  public hideConfirmationPopup(): void {
    this.modalRef.hide();
  }
}
